import { AxiosResponse } from 'axios';
import instance from '../../api/instance';
import {
  CompanyPaymentProvider,
  DraftCompanyPaymentProvider,
  PaymentMethod,
  PaymentProviderId,
} from './paymentProvider.types';

export type GetCompanyPaymentProviders = (params: {
  companyId: string;
}) => Promise<AxiosResponse<CompanyPaymentProvider>>;

export const getCompanyPaymentProviders: GetCompanyPaymentProviders = async ({ companyId }) => {
  return instance.get(`companies/${companyId}/payment-provider`).catch(e => e.response as never);
};

export type PostNewCompanyPaymentProvider = (params: {
  companyId: string;
  data: DraftCompanyPaymentProvider;
}) => Promise<AxiosResponse<CompanyPaymentProvider>>;

export const postNewCompanyPaymentProvider: PostNewCompanyPaymentProvider = async ({ companyId, data }) => {
  return instance.post(`companies/${companyId}/payment-provider`, data).catch(e => e.response as never);
};

export type DeleteCompanyPaymentProvider = (params: {
  companyId: string;
  providerId: PaymentProviderId;
}) => Promise<AxiosResponse<void>>;

export const deleteCompanyPaymentProvider: DeleteCompanyPaymentProvider = async ({ companyId, providerId }) => {
  return instance.post(`companies/${companyId}/payment-provider/${providerId}`).catch(e => e.response as never);
};

export type GetCompanyPaymentProvider = (params: {
  companyId: string;
  providerId: PaymentProviderId;
}) => Promise<AxiosResponse<CompanyPaymentProvider>>;

export const getCompanyPaymentProvider: GetCompanyPaymentProvider = async ({ companyId, providerId }) => {
  return instance.get(`companies/${companyId}/payment-provider/${providerId}`).catch(e => e.response as never);
};

export type UpdateCompanyPaymentProvider = (params: {
  companyId: string;
  providerId: PaymentProviderId;
  data: DraftCompanyPaymentProvider;
}) => Promise<AxiosResponse<CompanyPaymentProvider>>;

export const updateCompanyPaymentProvider: UpdateCompanyPaymentProvider = async ({ companyId, providerId, data }) => {
  return instance.post(`companies/${companyId}/payment-provider/${providerId}`, data).catch(e => e.response as never);
};

export type UpdateCompanyPaymentMethods = (params: {
  companyId: string;
  data: { methods: PaymentMethod[] };
}) => Promise<AxiosResponse<PaymentMethod[]>>;

export const updateCompanyPaymentMethods: UpdateCompanyPaymentMethods = async ({ companyId, data }) => {
  return instance.post(`companies/${companyId}/payment-methods`, data).catch(e => e.response as never);
};

export type GetPaymentMethods = () => Promise<AxiosResponse<PaymentMethod[]>>;

export const getPaymentMethods: GetPaymentMethods = async () => {
  return instance.get(`/companies/payment-methods`).catch(e => e.response as never);
};
